// src/services/studentService.ts
import axios from "axios";
import api from "./api";
import { fetchCertificates } from "./dashboardService";

export const getStudents = async () => {
  try {
    const response = await api.get("/students/list");

    console.log("Fetched students:", response.data);

    const students = response.data.students.map((s: any) => ({
      id: s.id,
      first_name: s.first_name,
      last_name: s.last_name,
      email: s.email,
      phone_number: s.phone_number,
      course_name: s.course_name,
      year_of_study: s.year_of_study,
      status: s.certificates && s.certificates.length > 0 ? "Certified" : "Not Certified",
      created_at: s.created_at,
    }));

    return {
      students,
      total: students.length,
    };
  } catch (error: any) {
    console.error("Failed to fetch students:", error);
    throw error.response?.data?.message || "Failed to fetch students";
  }
};


export const addStudent = async (studentData: {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  courseName: string;
  yearOfStudy: string;
  programStartDate: string;
  programEndDate: string;
  photoUrl: string;
}) => {
  try {
    const payload = {
      first_name: studentData.firstName,
      last_name: studentData.lastName,
      email: studentData.email,
      phone_number: studentData.phoneNumber,
      course_name: studentData.courseName,
      year_of_study: studentData.yearOfStudy,
      program_start_date: studentData.programStartDate,
      program_end_date: studentData.programEndDate,
      photo_url: studentData.photoUrl,
    };

    const response = await api.post("/students/create", payload);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to add student";
  }
};

export const verifyCertificate = async (code: string) => {
  try {
    // Manual verification (form/button) uses POST /certificate/verify
    const response = await api.post(`/certificate/verify`, { certificate_code: code });
    console.log("Verification response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Verification error:", error.response?.data || error.message);
    throw error.response?.data?.message || "Failed to verify certificate";
  }
};

export const verifyCertificateQR = async (certificateId: string) => {
  try {
    // QR-based verification uses GET /certificate/{code}
    const res = await api.get(`/certificate/${encodeURIComponent(certificateId)}`);
    const d = res.data;
    console.log("QR Verification response:", d);
    return d;
  } catch (error: any) {
    console.error("QR verification error:", error.response?.data || error.message);
    throw error.response?.data?.message || "Failed to verify certificate";
  }
};


// Update student (PUT /students/{student_id}/edit)
export const editStudent = async (studentId: number | string, studentData: any) => {
  try {
    const payload = {
      first_name: studentData.firstName,
      last_name: studentData.lastName,
      email: studentData.email,
      phone_number: studentData.phoneNumber,
      course_name: studentData.courseName,
      year_of_study: studentData.yearOfStudy,
      program_start_date: studentData.programStartDate,
      program_end_date: studentData.programEndDate,
      photo_url: studentData.photoUrl,
    };

    const response = await api.put(`/students/${studentId}/edit`, payload);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to update student";
  }
};


// Delete student (DELETE /students/{student_id}/delete)
export const deleteStudent = async (studentId: number | string) => {
  try {
    const response = await api.delete(`/students/${studentId}/delete`);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to delete student";
  }
};
